const SET_AUTOCOMPLETE_PREQUERY = 'SET_AUTOCOMPLETE_PREQUERY';

export { SET_AUTOCOMPLETE_PREQUERY };
